export default __webpack_public_path__ + "2d0f780b911329c0592befedafa584fa.jpg";